import { render, staticRenderFns } from "./addItemsToBin.vue?vue&type=template&id=3148abdc&scoped=true"
import script from "./addItemsToBin.vue?vue&type=script&lang=js"
export * from "./addItemsToBin.vue?vue&type=script&lang=js"
import style0 from "./addItemsToBin.vue?vue&type=style&index=0&id=3148abdc&prod&scoped=true&lang=css"
import style1 from "./addItemsToBin.vue?vue&type=style&index=1&id=3148abdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3148abdc",
  null
  
)

export default component.exports